import React from "react";
import Aside from "../../Components/aside";
import ExcludedComponent from "../../Components/ExcludedComponent";
import TopBar from "../../Components/topBar";
import { SnackbarProvider } from "notistack";
function ExcludedPage() {
  return (
    <SnackbarProvider>
      <div className="main-wrapper">
        <div className="content-wrapper">
          <ExcludedComponent />
        </div>
      </div>
    </SnackbarProvider>
  );
}

export default ExcludedPage;
